import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import SnackbarProvider from 'react-simple-snackbar'
import Home from './components/Home/Home';
import Invoice from './components/Invoice/Invoice';
import Invoices from './components/Invoices-DataGrid/Invoices';
import InvoiceDetails from './components/InvoiceDetails/InvoiceDetails'
import White from './components/White/White';
import Whites from './components/Whites-DataGrid/Whites';
import WhiteDetails from './components/WhiteDetails/WhiteDetails'
// import ClientList from './components/Clients/ClientList'
import ProductList from './components/Products-DataGrid/ProductList'
import Routes from './components/Routes/Routes'
import OrderSheet from './components/OrderSheet/OrderSheet'
import NavBar from './components/NavBar/NavBar';
import Login from './components/Login/Login'
import Dashboard from './components/Dashboard/Dashboard';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Settings from './components/Settings/Settings';
import Forgot from './components/Password/Forgot'
import Reset from './components/Password/Reset'
import RevenueDashboardPage from './pages/RevenueDashboardPage'
import RecentlyDeletedPage from './pages/RecentlyDeletedPage'
import ActivityLogPage from './pages/ActivityLogPage'
import OutstandingInvoicesPage from './pages/OutstandingInvoicesPage'
import QuoteBuilderPage from './pages/QuoteBuilderPage'
import QuotesPage from './pages/QuotesPage'
import RoutePlannerPage from './pages/RoutePlannerPage'
import RouteLoadSheetPage from './pages/RouteLoadSheetPage'
import RouteLoadSheetCollectionPage from './pages/RouteLoadSheetCollectionPage'
import Accounts from './components/Accounts/Accounts'
import Locations from './components/Locations/Locations'
import Contacts from './components/Contacts/Contacts'
import Orders from './components/Orders/Orders'
import OrderDetails from './components/Orders/OrderDetails'
import { refreshSession } from './actions/auth'
import { selectAuthData } from './store/selectors/authSelectors'

const RoutedFooter = () => {
  const location = useLocation()
  if (location.pathname === '/') return null
  return <Footer />
}

function AppShell() {
  const authData = useSelector(selectAuthData)
  const dispatch = useDispatch()
  const location = useLocation()
  const isHome = location.pathname === '/'

  useEffect(() => {
    dispatch(refreshSession())
  }, [dispatch])

  return (
    <div className="appShell">
      {authData && !isHome && (
        <div className="print-hidden">
          <NavBar />
        </div>
      )}
      <div className="print-hidden">
        <Header />
      </div>
      <div className="appMain" style={isHome ? undefined : { paddingTop: 80 }}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/invoice" exact component={Invoice} />
          <Route path="/quote-builder" exact component={QuoteBuilderPage} />
          <Route path="/quote-builder/:id" exact component={QuoteBuilderPage} />
          <Route path="/quotes" exact component={QuotesPage} />
          <Route path="/edit/invoice/:id" exact component={Invoice} />
          <Route path="/invoice/:id" exact component={InvoiceDetails} />
          <Route path="/white" exact component={White} />
          <Route path="/edit/white/:id" exact component={White} />
          <Route path="/invoices" exact component={Invoices} />
          <Route path="/white/:id" exact component={WhiteDetails} />
          {/* Whites hidden for now */}
          {/* <Route path="/whites" exact component={Whites} /> */}
          <Route path="/login" exact component={Login} />
          <Route path="/settings" exact component={Settings} />
          <Route path="/dashboard" exact component={Dashboard} />
          <Route path="/accounts" exact component={Accounts} />
          <Route path="/locations" exact component={Locations} />
          <Route path="/contacts" exact component={Contacts} />
          <Route path="/orders" exact component={Orders} />
          <Route path="/orders/:id" exact component={OrderDetails} />
          {/* Customers page hidden for now */}
          {/* <Route path="/customers" exact component={ClientList} /> */}
          <Route path="/products" exact component={ProductList} />
          {/* Routes hidden for now */}
          {/* <Route path="/routes" exact component={Routes} /> */}
          {/* <Route path="/routes/print" exact component={RouteLoadSheetCollectionPage} /> */}
          {/* <Route path="/routes/:planId" exact component={RouteLoadSheetPage} /> */}
          {/* <Route path="/routes/print" exact component={RouteLoadSheetCollectionPage} /> */}
          <Route path="/order-sheet" exact component={OrderSheet} />
          <Route path="/forgot" exact component={Forgot} />
          <Route path="/reset/:token" exact component={Reset} />
          <Route path="/analytics" exact component={RevenueDashboardPage} />
          <Route path="/recently-deleted" exact component={RecentlyDeletedPage} />
          <Route path="/activity-log" exact component={ActivityLogPage} />
          <Route path="/outstanding-invoices" exact component={OutstandingInvoicesPage} />
          {/* Route Planner hidden for now */}
          {/* <Route path="/routes-planner" exact component={RoutePlannerPage} /> */}
          <Redirect exact from="/new-invoice" to="/invoice" />
        </Switch>
      </div>
      <div className="print-hidden">
        <RoutedFooter />
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SnackbarProvider>
        <AppShell />
      </SnackbarProvider>
    </BrowserRouter>
  )
}

export default App;
